module.exports = __webpack_public_path__ + "img/landing-feature2.06fb9a2f.png";